import DynamicPageRenderer from "../../components/DynamicPageRenderer";

const PiliersTariqa = () => {
  return <DynamicPageRenderer slug="enseignements/piliers" />;
};

export default PiliersTariqa;
